import { useMediaQuery } from '@mui/material'
import React from 'react'

interface MediaQueryCheckProps {
	children: (matches: boolean) => React.JSX.Element
	matcher: Parameters<typeof useMediaQuery>[0]
}

export function MediaQueryCheck({ children, matcher }: MediaQueryCheckProps) {
	const matches = useMediaQuery(matcher)

	return children(matches)
}
